import { AfterViewInit, Component, ContentChildren, ElementRef, Input, OnInit, QueryList, ViewEncapsulation } from '@angular/core';
import { AtLabel } from '../directives/label.directive';
import { AD_SUFFIX, AtSuffix } from '../directives/suffix.directive';
import { AD_PREFIX, AtPrefix } from '../directives/prefix.directive';
import { AD_SUPPORT, AtSupport } from '../directives/support.directive';

export type FormFieldAppearance = 'standard' | 'outline';
export type FormFieldTheme = 'primary' | 'secondary' | 'tertiary' | 'magenta' | 'orange' | 'purple' | 'red' | 'teal' | 'yellow' | 'gray';

@Component({
  selector: 'at-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  host: {
    'class': 'at-form-field',
    '[class.at-form-field-primary]': 'theme === "primary"',
    '[class.at-form-field-secondary]': 'theme === "secondary"',
    '[class.at-form-field-tertiary]': 'theme === "tertiary"',
    '[class.at-form-field-magenta]': 'theme === "magenta"',
    '[class.at-form-field-orange]': 'theme === "orange"',
    '[class.at-form-field-purple]': 'theme === "purple"',
    '[class.at-form-field-red]': 'theme === "red"',
    '[class.at-form-field-teal]': 'theme === "teal"',
    '[class.at-form-field-yellow]': 'theme === "yellow"',
    '[class.at-form-field-gray]': 'theme === "gray"'
  },
  encapsulation: ViewEncapsulation.None
})
export class FormFieldComponent implements OnInit, AfterViewInit {
  @ContentChildren(AtLabel) _labelChild: AtLabel;
  @ContentChildren(AD_PREFIX, {descendants: true}) _prefixChildren: QueryList<AtPrefix>;
  @ContentChildren(AD_SUFFIX, {descendants: true}) _suffixChildren: QueryList<AtSuffix>;
  @ContentChildren(AD_SUPPORT, {descendants: true}) _supportChildren: QueryList<AtSupport>;

  @Input()
  get appearance(): FormFieldAppearance { return this._appearance; }
  set appearance(value: FormFieldAppearance) {
    this._appearance = value || 'standard';
  }
  _appearance: FormFieldAppearance;

  @Input()
  get theme(): FormFieldTheme { return this._theme; }
  set theme(value: FormFieldTheme) {
    this._theme = value || 'primary';
  }
  _theme: FormFieldTheme;

  type:string;

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    this.type = this.element.nativeElement.getElementsByClassName('at-input-element')[0].type;
    this.hasValue(this.element.nativeElement.getElementsByClassName('at-input-element')[0]);
  }

  ngAfterViewInit() {
    if (this._suffixChildren.length > 0) {
      if (this.type === 'password') {
        this.element.nativeElement.getElementsByClassName('at-form-field-suffix')[0].addEventListener('click', this._onChangeInput);
      }
    }
  }

  hasLabel() {
    return !!(this._labelChild);
  }

  onClick(event: Event) {
    event.preventDefault();
    let e = this.element.nativeElement.getElementsByClassName('at-input-element')[0];
    if (e === document.activeElement) {
      this.element.nativeElement.classList.add('at-form-field-focused');
      this.element.nativeElement.classList.add('at-form-field-label-float');
    }
  }

  onFocusOut(event: Event) {
    event.preventDefault();
    this.element.nativeElement.classList.remove('at-form-field-focused');
    let e = this.element.nativeElement.getElementsByClassName('at-input-element')[0];
    if (e.value.length > 0) {
      this.element.nativeElement.classList.add('at-form-field-label-float');
    }
    else {
      this.element.nativeElement.classList.remove('at-form-field-label-float');
    }
  }

  onChangeInput(event: Event) {
    event.preventDefault();
    let e = this.element.nativeElement.getElementsByClassName('at-input-element')[0];
    if (e.type === 'password') {
      e.type = 'text';
    } else if (e.type === 'text') {
      e.type = 'password';
    }
  }
  _onChangeInput = this.onChangeInput.bind(this);

  hasValue(element) {
    console.log(element.value.length);
    if (element.value.length > 0) {
      this.element.nativeElement.classList.add('at-form-field-label-float');
    }
  }
}

